import { OptionGroupProps, SelectOption } from '@ott/select';

const defaultOptionFilter = <T extends OptionGroupProps | SelectOption>(
  options: T[],
  inputValue: string
) => {
  return options.filter((option) => {
    if (option.isOptionGroup && !inputValue) {
      return true;
    } else if (option.isOptionGroup) {
      return false;
    }

    const preparedLabel = option.label.toLowerCase();
    const preparedValue = inputValue.toLowerCase();

    return preparedLabel.includes(preparedValue);
  });
};

export default defaultOptionFilter;
